import { render, staticRenderFns } from "./MockImage.vue?vue&type=template&id=3283dad5&"
import script from "./MockImage.vue?vue&type=script&lang=js&"
export * from "./MockImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports